<template>
  <div>
    <div class="row justify-content-end">
      <div class="col-auto">
        <button
          @click="$router.push({ name: 'quotations-items-create' })"
          class="btn btn-primary"
        >
          <i class="bi bi-plus-square"></i>
          Créer
        </button>
      </div>
      <div class="col-auto">
        <button @click="refresh()" class="btn btn-info">
          <i class="bi bi-arrow-clockwise"></i>
          Actualiser
        </button>
      </div>
    </div>
    <br />
    <table class="table table-striped table-hover">
      <thead>
        <tr>
          <th scope="col"></th>
          <th scope="col">Référence</th>
          <th scope="col">Nom Complet</th>
          <th scope="col">Date</th>
          <th scope="col">Montant Total</th>
          <th scope="col">Total Quantité</th>
          <th scope="col">Créer par</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(quotation, index) in quotations" :key="index++">
          <td>
            {{ index }}
          </td>
          <td>
            {{ quotation.reference }}
          </td>
          <td>
            <span v-if="quotation.customer">
              {{ quotation.customer.fullName }}
            </span>
          </td>
          <td>{{ quotation.date }}</td>
          <td>
            <span v-if="quotation.totalPriceTTC != null" class="text-info">
              {{ quotation.totalPriceTTC }}
            </span>
            DH
          </td>
          <td>
            <span v-if="quotation.totalQuantity != null" class="text-warning">
              {{ quotation.totalQuantity }}
            </span>
          </td>

          <td>
            <span v-if="quotation.user">
              {{ quotation.user.name }}
            </span>
          </td>
          <td class="p-0 m-0">
            <button
              @click="
                $router.push({
                  name: 'quotations-details',
                  params: { reference: quotation.reference },
                })
              "
              class="btn"
            >
              <i class="bi bi-info-square fs-5"></i>
            </button>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  data() {
    return {
      search_value: "",
      addedToday: false,
      sortValue: "",
    };
  },
  computed: {
    ...mapGetters("quotation", {
      quotations: "getAll",
    }),
  },
  mounted() {
    this.$store.dispatch("quotation/getAll");

    // setInterval(() => {
    //   this.$store.dispatch("quotation/getAll");
    // }, 3000);
  },
  methods: {
    async search(value) {
      return await this.$store.commit("quotation/search", value);
    },
    async refresh() {
      return await this.$store.dispatch("quotation/getAll");
    },

    async listQuotations(checkbox) {
      if (checkbox == true) {
        console.log(checkbox);
        return await this.$store.commit("quotation/getTodays");
      } else {
        return await this.$store.dispatch("quotation/getQuotations");
      }
    },
    async sort(value) {
      return await this.$store.commit("quotation/sort", value);
    },
  },
};
</script>
